<div class="content-blk">
  <div class="container">
    <div class="row">
      <!-- FILTER -->
      <div class="col-sm-3">
          <div class="filtr-wrap">
            <h3 class="fltr-head">Filter 
                <button mat-icon-button [disabled]=isDisableFilterBtn (click)="fn_ClearFilter()">
                    Clear
                </button>
            </h3>
           <!--Category and Sub-Category Filter-->
           <nav>
            <ul class="nav">
               <li class="end-cat-blk-act">
                  <a href="#" id="btn-1" data-toggle="collapse" class="collapsed" data-target="#submenu1" aria-expanded="false">Category
                    <span class="mat-expansion-indicator end-ctg-exp"></span>
                  </a>
                  <div class="end-sb-ct-sbmn">
                    <ul class="nav collapse" id="submenu1" role="menu" aria-labelledby="btn-1" *ngFor="let category of catlist ; let i = index">
                        <li>
                          <a class="collapsed" style="cursor:pointer" (click)=" category.SubCategories.length == 0? fn_SelectCategory(category.ID): '' " data-toggle="collapse" [attr.data-target]="'#cat' + i" aria-expanded="false">
                            {{category.Name}}
                            <svg class="svg-ct-arw" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 129 129"> <g>  <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"/>
</g></svg>
                          </a>
                          <ul class="nav collapse" id="cat{{i}}" role="menu" aria-labelledby="btn-1" *ngFor="let subcategory of category.SubCategories">
                              <li>
                                <a style="cursor:pointer" (click)="fn_SelectCategory(subcategory.ID)">{{subcategory.Name}}</a>
                              </li>
                          </ul>
                       </li>
                    </ul>
                  </div>
                </li>
            </ul>
         </nav>
            <!-- Brand -->
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Brand
                  </mat-panel-title>					      
                </mat-expansion-panel-header>
                <ul>
                    <span *ngIf="filterList.Brands.length == 0" class="text-center">No brands found</span>
                  <li *ngFor="let brand of filterList.Brands">
                    <mat-checkbox #brandCheckbox (change)="fn_SelectBrand($event, brand.ManufacturerId)">{{brand.Manufacturer}}</mat-checkbox>
                  </li>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
  
            <!-- Color -->
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Color
                  </mat-panel-title>					      
                </mat-expansion-panel-header>
                <ul>
                    <span *ngIf="filterList.Colors.length == 0" class="text-center">No colors found</span>
                <li *ngFor="let color of filterList.Colors"> 
                    <mat-checkbox  #colorCheckbox (change)="fn_SelectColor($event, color.ColorName)"><span [style.backgroundColor]="color.ColorHexCode"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                      </span>&nbsp;&nbsp;{{color.ColorName}}
                    </mat-checkbox> 
                  </li>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
  
            <!-- Size -->
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Size
                  </mat-panel-title>					      
                </mat-expansion-panel-header>
                <ul>
                    <span *ngIf="filterList.Sizes.length == 0" class="text-center">No sizes found</span>
                  <li *ngFor="let size of filterList.Sizes">
                    <mat-checkbox #sizeCheckbox (change)="fn_SelectSize($event, size)">{{size}}</mat-checkbox>
                  </li>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>  
          </div>
        </div>
      <!-- /FILTER -->
      <div class="col-sm-9">
        <div class="search-results" infiniteScroll [infiniteScrollDistance]="1"   [infiniteScrollThrottle]="100" (scrolled)="fn_GetSavedDesignListing(false)">            
            <div class="row">          
                <!-- REPEAT -->
                <div class="col-sm-12" *ngIf="customizedProducts?.length !== 0">
                    <div class="search-top text-right srch-tp-cstm">
                        <form class="example-form" [formGroup] = "searchCustomizedForm">
                        <div class="srch-flt-rt">
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="Search" formControlName="searchProduct" ng-model-options="{debounce: 10000}" (change)="fn_searchCustomizeProduct(searchCustomizedForm)">
                          </mat-form-field>
                          </div>
                      </form>
                        
                      </div>
                  </div>
                <div class="col-sm-4 ovt-trns-ttl" *ngFor="let product of customizedProducts">
                  <div class="store-item">
                    <div class="store-item-thumb">
                      <div class="cstm-prdct display-table">
                          <div class="display-cell">
                              <img src="{{imgBaseURL + product.PngRelativeUrlWithProduct}}">
                              <div class="end-list-lnk">
                                <ul>
                                    <li><a class="adwscart" [routerLink]="['../product/details']" [queryParams]="{ pid: product.ProductId,designId:product.DesignId,type:1}">Details</a></li>
                                  <li><a class="adcart" (click)="fn_deleteCustomizedProduct(product.CustomizedProductId, product.DesignId, product.StyleId, product.ProductId)">Delete</a></li>
                                </ul>
                              </div>
                          </div>                          
                      </div>                      
                    </div>
                    <div class="end-store-item-cntnt">
                      <!-- Design Name -->
                      <h4>{{product.Name}}</h4>  
                      <!-- Product description -->
                      <h4>{{ product.ProductDescription.length> 40 ? (product.ProductDescription.ProductName | slice:0:40)+'..':(product.ProductDescription.ProductName) }}</h4>
                      <!-- <p>$ {{product.UnitCost}}</p> -->
                    </div>
                  </div>
                </div>      
              </div>
              <!-- <h6 *ngIf="customizedProducts.length == 0" class="text-center"> No result found</h6> -->
              <mat-card class="spg-mat-card mat-card-cmn" *ngIf="customizedProducts == null || customizedProducts?.length == 0">
                <mat-card-header>
                  <mat-card-title>MY DESIGNS (0) </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="text-center">
                    <img src="assets/img/emptycart.PNG">
                    <span> Seems to be you do not have any saved designs</span>
                  </div>
                </mat-card-content>
              </mat-card>
        </div>
        <app-lazy-loader></app-lazy-loader>
      </div>
    </div>
  </div>
</div>
